import { Link } from 'react-router-dom';
import { LoginBackground } from './LoginBackground';
import './LoginPanel.css';
import { BRAND, PROVIDER } from '../../../brand';

/** Which social sign-ins an invite offers, per Contractor.allowed_login_providers.
 *  Defaults to allowed: no invite (plain /login) or an unvalidated/invalid token must not
 *  silently strip a login method from everyone else. */
export const providerAllowedForInvite = (invite, provider) =>
  !invite?.allowed_login_providers || invite.allowed_login_providers.includes(provider);

export function LoginPanel({
  visible,
  username,
  setUsername,
  password,
  setPassword,
  handleLogin,
  handleGoogleLogin,
  handleAppleLogin,
  isLoading,
  errMsg,
  userRef,
  invite,
  inviteToken,
}) {
  



  return (
    <div className={`login-panel ${visible ? 'visible' : ''}`} >
      {/* Animated Three.js background */}
      {visible && <LoginBackground />}

      <div className="login-content glass-panel">
        {inviteToken && invite && (
          invite.error ? (
            <div className="invite-banner invite-banner--error">
              유효하지 않은 초대 링크입니다.
            </div>
          ) : (
            <div className="invite-banner">
              <div className="invite-badge">
                <span className="invite-ic">{invite.contractor_name ? invite.contractor_name.charAt(0).toUpperCase() : '?'}</span>
                <strong className="invite-name">{invite.contractor_name}</strong>
                <span className="invite-label">파트너 초대</span>
              </div>
              <p className="invite-sub">로그인하여 합류를 완료하세요.</p>
            </div>
          )
        )}

        {errMsg && (
          <div className="login-error-message" style={{ color: '#ff4444', marginBottom: '16px', textAlign: 'center' }}>
            {errMsg}
          </div>
        )}

        {/* Brand wordmark */}
        <div className="logo-section">
          <img src="/ace-logo-dark.png" alt={BRAND} className="muse-logo-img" />
          <h1 className="brand-name">{BRAND}</h1>
          <p className="brand-provider">{PROVIDER}</p>
          <p className="brand-legal">
            <Link to="/terms">이용약관</Link>
            <span> · </span>
            <Link to="/privacy">개인정보처리방침</Link>
          </p>
        </div>

        {/* Login Form */}
        <form className="login-form" onSubmit={handleLogin}>
          <div className="input-group">
            <input
              type="text"
              id="username"
              placeholder="Username"
              ref={userRef}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="login-input glass-input"
              required
              autoComplete="off"
            />
          </div>
          <div className="input-group">
            <input
              type="password"
              id="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="login-input glass-input"
              required
            />
          </div>
          <button type="submit" className="login-button glass-button" disabled={isLoading}>
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div className="login-divider">
          <span>or</span>
        </div>

        {/* Social Login Buttons. A 파트너 can be restricted to some providers; don't offer
            the others as a way in. This only hides them for someone arriving on such an
            invite — it is not an enforcement boundary, since /login without a token offers
            everything. Onboarding refuses the wrong provider server-side. */}
        <div className="social-buttons">
          {providerAllowedForInvite(invite, 'apple.com') && (
            <button className="social-button glass-button" onClick={handleAppleLogin} disabled={isLoading}>
              <span className="apple-icon"></span>
              Sign in with Apple
            </button>
          )}
          {providerAllowedForInvite(invite, 'google.com') && (
            <button className="social-button glass-button" onClick={handleGoogleLogin} disabled={isLoading}>
              <span className="google-icon">G</span>
              Sign in with Google
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
